/* eslint-disable */
// TODO: reconfigure eslint rules w team

/**
 * globals.js
 * desc: manages localization globals
 * note: this is temporary implementation until second locale is introduced
 * ......................................................
 * TODO: outstanding list
 *  |_ need to determine how to handle globals
 *  |_ make sure dictionaries build 1x only (no race conditions)
 *  |_ store dictionaries somewhere accessible to entire app (window||redux||file)
 *  |_ make sure dictionaries are available to all components (not just containers)
 *  |_ check if user locale supported, otherwise fallback to settings.locales.DEFAULT
 * ......................................................
 */
 'use strict';

 import { createDictionaries } from './dictionaries';
 import { getQueryStringObject } from '../helpers';
 import settings from '../settings/app-settings.json';
 
 
 // globals
 const dictionaries = createDictionaries();
 const qsObj = getQueryStringObject();
 
 let userLocale = ((qsObj.locale) ? qsObj.locale : navigator.language ? navigator.language : 'en-us').toLowerCase();

 // this is done on purpose until there is resolution for Canadian sites
 if (userLocale === "fr-ca") {
    userLocale = "en-us";
  }

 // check if user locale supported and enabled
let locale;
if (settings.locales.SUPPORTED.indexOf(userLocale) !== -1
  && settings.locales.ENABLED.includes(userLocale)) {
  locale = userLocale;
} else {
  // if userLocale is not supported or not enabled, check if we have a fallback
  const fallbackLocale = settings.locales.FALLBACK[userLocale];
  if (fallbackLocale && settings.locales.SUPPORTED.includes(fallbackLocale) && settings.locales.ENABLED.includes(fallbackLocale)) {
    locale = fallbackLocale;
  } else {
    locale = settings.locales.DEFAULT;
  }
}
 let [language, languageCountry] = locale.split('-');
 const defaultLanguageCountry = {
  'cs': 'cz',
  'hu': 'hu',
  'es': 'es',
  'pl': 'pl',
  'it': 'it',
  'de': 'de',
  'en': 'us',
  'en-ca': 'ca',
  'en-au': 'au',
  'fr-ca': 'ca',
  'en-gb': 'gb',
  'es-ar': 'ar',
  'en-ar': 'ar',
  'pt-br': 'br',
  'de-at': 'at',
  'nl-nl': 'nl',
  'nl': 'nl',
  'sv': 'se',
  "sv-fi": "se",
  "sv-se": "se",
  "sv-ax": "se"
 }
 
 if (defaultLanguageCountry[locale] == "se") languageCountry = "se";
 const country = languageCountry || defaultLanguageCountry[locale] || defaultLanguageCountry[language] || 'us';

 export { locale, dictionaries, qsObj, language, country };
 